import { Controller } from '@hotwired/stimulus'
import { toggle } from '../../lib/dom'

export default class extends Controller {
  static targets = ['step']

  connect() {
    if (this.stepTargets.length > 1) {
      this.animationInterval = setInterval(() => this.toggleSteps(), 3000)
    }
  }

  disconnect() {
    clearInterval(this.animationInterval)
  }

  toggleSteps() {
    const [stepToHide, stepToShow] = this.toggleStepTargets

    toggle(stepToHide, false)
    toggle(stepToShow, true)
  }

  get toggleStepTargets() {
    this.currentStepIndex ||= 0

    const nextStepIndex =
      this.currentStepIndex + 1 > this.stepTargets.length - 1
        ? 0
        : this.currentStepIndex + 1
    const targets = [
      this.stepTargets[this.currentStepIndex],
      this.stepTargets[nextStepIndex],
    ]

    this.currentStepIndex = nextStepIndex

    return targets
  }
}
